var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStoreAddressFill = function SvgIcStoreAddressFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.704 3.257A6 6 0 0 1 16 8.803c0 2.325-1.629 4.764-3 6.402a25.5 25.5 0 0 1-3 3.027 25.5 25.5 0 0 1-3-3.027c-1.371-1.638-3-4.077-3-6.402a6 6 0 0 1 3.704-5.546m2.298 3.402a2.316 2.316 0 1 0 0 4.63 2.316 2.316 0 0 0 0-4.63"
  })));
};
export default SvgIcStoreAddressFill;